import React, { useState, Fragment, useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
// import { ThemeProvider, StyledEngineProvider, makeStyles } from '@mui/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import TopActions from '../actions/TopActions';
import Toast from '../actions/Toasts';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import apiService from '../../services/apiServices';
import InputController from '../../controllers/InputController';

export default function AddBranch() {
  //const classes = useStyles();
  const alert = { open: false, message: '', variant: '' };
  const [toast, setToast] = useState(alert);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      Status: true,
    },
  });

  useEffect(() => {
    apiService()
      .get('branch')
      .then((response) => {
        if (!response.success) {
          console.error('Error:' + response.errorMessage);
        }
      });
  }, []);


  const onSubmit = (data) => {
    const statusValue = data?.Status;
    let statusId = statusValue;
    if (typeof statusValue === 'boolean') {
      statusId = statusValue ? 1 : 2;
    } else if (statusValue && typeof statusValue === 'object') {
      statusId =
        statusValue.id ??
        statusValue.Id ??
        statusValue.status ??
        statusValue.Status;
    }
    if (statusId !== undefined) {
      data.Status = statusId;
    }
    console.log(data);
    apiService()
      .post('branch', data)
      .then((response) => {
        if (response.success) {
          setToast({
            open: true,
            message: 'U ruajten me sukses!',
            variant: 'success',
          });
        } else {
          setToast({
            open: true,
            message: 'Ka ndodhur nje gabim!',
            variant: 'error',
          });
        }
      });
  };

  return (
    <div className="">
      <Fragment>
        <Toast {...toast} />
        <TopActions
          newHref="/branchlist/addbranch"
          save={handleSubmit(onSubmit)}
        />

        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Lloji i Filialit
            </Typography>
            <form>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={3} lg={4}>
                  <InputController
                    placeholder="Emri i Filialit"
                    error={errors.Name}
                    control={control}
                    name="Name"
                    register={{ ...register('Name') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={4}>
                  <InputController
                    placeholder="Inicialet"
                    error={errors.ShortName}
                    control={control}
                    name="ShortName"
                    register={{ ...register('ShortName') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={4}>
                  <Controller
                    name="Status"
                    control={control}
                    defaultValue={true}
                    render={({ field }) => (
                      <FormControlLabel
                        control={
                          <Switch
                            {...field}
                            checked={Boolean(field.value)}
                            onChange={(event) =>
                              field.onChange(event.target.checked)
                            }
                            color="primary"
                          />
                        }
                        label={field.value ? 'Aktiv' : 'Jo aktiv'}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </form>
          </CardContent>
        </Card>
      </Fragment>
    </div>
  );
}
